import {
  Accordion,
  Center,
  Flex,
  Loader,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { Pagination } from "../../../../components";
import { DocumentText } from "iconsax-react";
import { useState } from "react";
import TableHistory from "./TableHistory";
import { EPlanStatus, IMyPlans } from "../../../../interfaces/MyPlans/IMyPlans";
import { useMyHistoryPlans } from "../../../../hooks/useMyPlans";
import { IQuery } from "../../../../interfaces/IQuery";
import { useTranslation } from "react-i18next";

interface IProps {
  product: IMyPlans;
}

const AccordionHistory = ({ product }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const [query, setQuery] = useState<IQuery>({
    page: 1,
    pageSize: 10,
    id: "",
  });
  const { data: history, isLoading: isLoadingHistory } =
    useMyHistoryPlans(query);

  const pagination = {
    page: query.page,
    pageSize: query.pageSize,
    totalElements: history?.totalElements,
    totalPages: history?.totalPages,
    view: history?.data?.length || 0,
  };

  const handleOpenHistory = () => {
    setQuery((prev) => ({ ...prev, id: product.id }));
  };

  return (
    <Accordion.Item value="History" onClick={handleOpenHistory} w={"100%"}>
      <Accordion.Control p="0">
        <Flex
          id="lineOneCardProduct"
          justify="start"
          align={"center"}
          gap="8px"
        >
          <DocumentText size="24" color={theme.colors.basic[5]} />
          <Text
            fz={{ base: 18 }}
            lh={{ base: "155%" }}
            c={theme.colors.basic[5]}
          >
            {t(
              "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.title"
            )}
          </Text>
        </Flex>
      </Accordion.Control>
      <Accordion.Panel
        styles={{
          ".content": {
            padding: "0px",
            width: "100%",
          },
        }}
      >
        {isLoadingHistory ? (
          <Center h="200px" w="100%">
            <Loader />
          </Center>
        ) : history && history.data.length > 0 ? (
          <Flex
            gap={{ base: 16 }}
            maw="100%"
            direction={"column"}
            justify={"space-between"}
            p="16px 0"
          >
            <TableHistory
              history={history}
              idProduct={product.id}
              isDisabled={
                !(
                  product.status === EPlanStatus.Approved ||
                  product.status === EPlanStatus.InProcessing ||
                  product.status === EPlanStatus.CancelRequested
                )
              }
            />

            <Pagination
              pagination={pagination}
              onChange={(page) => setQuery({ ...query, page: page })}
            />
          </Flex>
        ) : (
          <Flex
            gap={{ base: 16 }}
            w="fit"
            direction={"column"}
            justify={"space-between"}
            p="16px 0"
          >
            <Text>{t("global.pagination.no_registered")}</Text>
          </Flex>
        )}
      </Accordion.Panel>
    </Accordion.Item>
  );
};
export default AccordionHistory;
